<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="用户id" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户id" />
      </a-form-model-item>
      <a-form-model-item label="身高(厘米)" prop="height" >
        <a-input v-model="form.height" placeholder="请输入身高(厘米)" />
      </a-form-model-item>
      <a-form-model-item label="身高单位id(外键sys_config.id)" prop="heightUnit" >
        <a-input v-model="form.heightUnit" placeholder="请输入身高单位id(外键sys_config.id)" />
      </a-form-model-item>
      <a-form-model-item label="体重(kg)" prop="weight" >
        <a-input v-model="form.weight" placeholder="请输入体重(kg)" />
      </a-form-model-item>
      <a-form-model-item label="体重单位id(外键sys_config.id)" prop="weightUnit" >
        <a-input v-model="form.weightUnit" placeholder="请输入体重单位id(外键sys_config.id)" />
      </a-form-model-item>
      <a-form-model-item label="温度(摄氏度)" prop="temperature" >
        <a-input v-model="form.temperature" placeholder="请输入温度(摄氏度)" />
      </a-form-model-item>
      <a-form-model-item label="温度单位id(外键sys_config.id)" prop="temperatureUnit" >
        <a-input v-model="form.temperatureUnit" placeholder="请输入温度单位id(外键sys_config.id)" />
      </a-form-model-item>
      <a-form-model-item label="距离" prop="distance" >
        <a-input v-model="form.distance" placeholder="请输入距离" />
      </a-form-model-item>
      <a-form-model-item label="血压私人模式-收缩压" prop="shrinkPressure" >
        <a-input v-model="form.shrinkPressure" placeholder="请输入血压私人模式-收缩压" />
      </a-form-model-item>
      <a-form-model-item label="是否开启低氧唤醒 0-否 1-是" prop="lowOxygen" >
        <a-input v-model="form.lowOxygen" placeholder="请输入是否开启低氧唤醒 0-否 1-是" />
      </a-form-model-item>
      <a-form-model-item label="血压私人模式-舒张压" prop="diastolePressure" >
        <a-input v-model="form.diastolePressure" placeholder="请输入血压私人模式-舒张压" />
      </a-form-model-item>
      <a-form-model-item label="距离单位id(外键sys_config.id)" prop="distanceUnit" >
        <a-input v-model="form.distanceUnit" placeholder="请输入距离单位id(外键sys_config.id)" />
      </a-form-model-item>
      <a-form-model-item label="性别,0-保密 1-男 2-女" prop="sex" >
      </a-form-model-item>
      <a-form-model-item label="生日，格式1990-04-22" prop="birthday" >
      </a-form-model-item>
      <a-form-model-item label="肤色(色号码)" prop="skinColour" >
        <a-input v-model="form.skinColour" placeholder="请输入肤色(色号码)" />
      </a-form-model-item>
      <a-form-model-item label="女性上次来月经时间" prop="lastTime" >
        <a-date-picker style="width: 100%" v-model="form.lastTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="女性上次来月经周期天数" prop="lastCycle" >
        <a-input v-model="form.lastCycle" placeholder="请输入女性上次来月经周期天数" />
      </a-form-model-item>
      <a-form-model-item label="女性上次来月经天数" prop="lastDays" >
        <a-input v-model="form.lastDays" placeholder="请输入女性上次来月经天数" />
      </a-form-model-item>
      <a-form-model-item label="心率报警值" prop="heartPolic" >
        <a-input v-model="form.heartPolic" placeholder="请输入心率报警值" />
      </a-form-model-item>
      <a-form-model-item label="是否开启心率报警" prop="isHeartPolic" >
        <a-input v-model="form.isHeartPolic" placeholder="请输入是否开启心率报警" />
      </a-form-model-item>
      <a-form-model-item label="是否开启血糖私人模式0-否 1-是" prop="isPriveBloodSugar" >
        <a-input v-model="form.isPriveBloodSugar" placeholder="请输入是否开启血糖私人模式0-否 1-是" />
      </a-form-model-item>
      <a-form-model-item label="血糖私人模式早餐前标准值(毫摩尔/升)" prop="morningBloodSugarBefore" >
        <a-input v-model="form.morningBloodSugarBefore" placeholder="请输入血糖私人模式早餐前标准值(毫摩尔/升)" />
      </a-form-model-item>
      <a-form-model-item label="血糖私人模式早餐后标准值(毫摩尔/升)" prop="morningBloodSugarAfter" >
        <a-input v-model="form.morningBloodSugarAfter" placeholder="请输入血糖私人模式早餐后标准值(毫摩尔/升)" />
      </a-form-model-item>
      <a-form-model-item label="血糖私人模式午餐前标准值(毫摩尔/升)" prop="noonBloodSugarBefore" >
        <a-input v-model="form.noonBloodSugarBefore" placeholder="请输入血糖私人模式午餐前标准值(毫摩尔/升)" />
      </a-form-model-item>
      <a-form-model-item label="血糖私人模式午餐后标准值(毫摩尔/升)" prop="noonBloodSugarAfter" >
        <a-input v-model="form.noonBloodSugarAfter" placeholder="请输入血糖私人模式午餐后标准值(毫摩尔/升)" />
      </a-form-model-item>
      <a-form-model-item label="血糖私人模式晚餐前标准值(毫摩尔/升)" prop="nightBloodSugarBefore" >
        <a-input v-model="form.nightBloodSugarBefore" placeholder="请输入血糖私人模式晚餐前标准值(毫摩尔/升)" />
      </a-form-model-item>
      <a-form-model-item label="血糖私人模式晚餐后标准值(毫摩尔/升)" prop="nightBloodSugarAfter" >
        <a-input v-model="form.nightBloodSugarAfter" placeholder="请输入血糖私人模式晚餐后标准值(毫摩尔/升)" />
      </a-form-model-item>
      <a-form-model-item label="是否开启血液成分检测私人模式" prop="isPrivateBloodComponents" >
        <a-input v-model="form.isPrivateBloodComponents" placeholder="请输入是否开启血液成分检测私人模式" />
      </a-form-model-item>
      <a-form-model-item label="血液成分检测私人模式尿酸值(微摩尔/升)" prop="bloodUricAcid" >
        <a-input v-model="form.bloodUricAcid" placeholder="请输入血液成分检测私人模式尿酸值(微摩尔/升)" />
      </a-form-model-item>
      <a-form-model-item label="血液成分检测私人模式总胆固醇值(微摩尔/升)" prop="bloodCholesterol" >
        <a-input v-model="form.bloodCholesterol" placeholder="请输入血液成分检测私人模式总胆固醇值(微摩尔/升)" />
      </a-form-model-item>
      <a-form-model-item label="血液成分检测私人模式甘油三酯值(微摩尔/升)" prop="bloodTriglyceride" >
        <a-input v-model="form.bloodTriglyceride" placeholder="请输入血液成分检测私人模式甘油三酯值(微摩尔/升)" />
      </a-form-model-item>
      <a-form-model-item label="血液成分检测私人模式高密度脂蛋白(微摩尔/升)" prop="bloodHighLipoprotein" >
        <a-input v-model="form.bloodHighLipoprotein" placeholder="请输入血液成分检测私人模式高密度脂蛋白(微摩尔/升)" />
      </a-form-model-item>
      <a-form-model-item label="血液成分检测私人模式低密度脂蛋白(微摩尔/升)" prop="bloodLowLipoprotein" >
        <a-input v-model="form.bloodLowLipoprotein" placeholder="请输入血液成分检测私人模式低密度脂蛋白(微摩尔/升)" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getBody, addBody, updateBody } from '@/api/joe/body'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        height: null,

        heightUnit: null,

        weight: null,

        weightUnit: null,

        temperature: null,

        temperatureUnit: null,

        distance: null,

        shrinkPressure: null,

        lowOxygen: null,

        diastolePressure: null,

        distanceUnit: null,

        sex: null,

        birthday: null,

        skinColour: null,

        lastTime: null,

        lastCycle: null,

        lastDays: null,

        heartPolic: null,

        isHeartPolic: null,

        isPriveBloodSugar: null,

        morningBloodSugarBefore: null,

        morningBloodSugarAfter: null,

        noonBloodSugarBefore: null,

        noonBloodSugarAfter: null,

        nightBloodSugarBefore: null,

        nightBloodSugarAfter: null,

        isPrivateBloodComponents: null,

        bloodUricAcid: null,

        bloodCholesterol: null,

        bloodTriglyceride: null,

        bloodHighLipoprotein: null,

        bloodLowLipoprotein: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '用户id不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        height: null,
        heightUnit: null,
        weight: null,
        weightUnit: null,
        temperature: null,
        temperatureUnit: null,
        distance: null,
        shrinkPressure: null,
        lowOxygen: null,
        diastolePressure: null,
        distanceUnit: null,
        sex: null,
        birthday: null,
        skinColour: null,
        lastTime: null,
        lastCycle: null,
        lastDays: null,
        heartPolic: null,
        isHeartPolic: null,
        isPriveBloodSugar: null,
        morningBloodSugarBefore: null,
        morningBloodSugarAfter: null,
        noonBloodSugarBefore: null,
        noonBloodSugarAfter: null,
        nightBloodSugarBefore: null,
        nightBloodSugarAfter: null,
        isPrivateBloodComponents: null,
        bloodUricAcid: null,
        bloodCholesterol: null,
        bloodTriglyceride: null,
        bloodHighLipoprotein: null,
        bloodLowLipoprotein: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getBody({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateBody(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addBody(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
